/* eslint-disable */
import Long from 'long';
import * as _m0 from 'protobufjs/minimal';

export const protobufPackage = 'od_protos.journey.data';

/** Next ID: 5 */
export interface WebsiteSource {
  url: string;
  userAgent?: string;
  ip?: string;
  referrer?: string;
}

/** Next ID: 2 */
export interface BackendSource {
  name: string;
}

function createBaseWebsiteSource(): WebsiteSource {
  return { url: '', userAgent: undefined, ip: undefined, referrer: undefined };
}

export const WebsiteSource = {
  fromJSON(object: any): WebsiteSource {
    return {
      url: isSet(object.url) ? String(object.url) : '',
      userAgent: isSet(object.userAgent) ? String(object.userAgent) : undefined,
      ip: isSet(object.ip) ? String(object.ip) : undefined,
      referrer: isSet(object.referrer) ? String(object.referrer) : undefined,
    };
  },

  toJSON(message: WebsiteSource): unknown {
    const obj: any = {};
    message.url !== undefined && (obj.url = message.url);
    message.userAgent !== undefined && (obj.userAgent = message.userAgent);
    message.ip !== undefined && (obj.ip = message.ip);
    message.referrer !== undefined && (obj.referrer = message.referrer);
    return obj;
  },

  fromPartial<I extends Exact<DeepPartial<WebsiteSource>, I>>(object: I): WebsiteSource {
    const message = createBaseWebsiteSource();
    message.url = object.url ?? '';
    message.userAgent = object.userAgent ?? undefined;
    message.ip = object.ip ?? undefined;
    message.referrer = object.referrer ?? undefined;
    return message;
  },
};

function createBaseBackendSource(): BackendSource {
  return { name: '' };
}

export const BackendSource = {
  fromJSON(object: any): BackendSource {
    return {
      name: isSet(object.name) ? String(object.name) : '',
    };
  },

  toJSON(message: BackendSource): unknown {
    const obj: any = {};
    message.name !== undefined && (obj.name = message.name);
    return obj;
  },

  fromPartial<I extends Exact<DeepPartial<BackendSource>, I>>(object: I): BackendSource {
    const message = createBaseBackendSource();
    message.name = object.name ?? '';
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin
  ? T
  : T extends Array<infer U>
  ? Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U>
  ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string }
  ? { [K in keyof Omit<T, '$case'>]?: DeepPartial<T[K]> } & { $case: T['$case'] }
  : T extends {}
  ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin
  ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & Record<Exclude<keyof I, KeysOfUnion<P>>, never>;

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
